import { createSlotRecipe } from './runtime';

const siteNavConfig = {"name":"siteNav","slots":["root","bar","inner","start","brand","avatar","links","link","indicator","actions"]}

export const siteNav = /* @__PURE__ */ createSlotRecipe(siteNavConfig)